module.exports = {
      id: "visibility-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#visibility",
      toString: function () {
        return this.url;
      }
    }